import { PriceLevelSwitcher } from "./components/PriceLevelSwitcher";
import { SummaryEstimateCodeCell } from "./components/SummaryEstimateCodeCell/SummaryEstimateCodeCell";

export default function SummaryEstimateTableColumns({ headerData, priceLevel, setPriceLevel }) {
	return [
		{
			name: "num",
			title: "№ п/п",
			width: "30px",
			cellHorAlign: "center",
			headHorAlign: "left",
			rowSpan: "2",
			headHeight: "30px",
			marginLeft: "10px",
		},
		{
			name: "code",
			title: "Обоснование",
			width: "250px",
			cellHorAlign: "left",
			headHorAlign: "left",
			rowSpan: "2",
			headHeight: "30px",
			marginLeft: "10px",
			cellJsx: ({ rowObj, clmName, clmObj }) => <SummaryEstimateCodeCell rowObj={rowObj} clmName={clmName} clmObj={clmObj} />,
		},
		{
			name: "name",
			title: "Наименование работ и затрат",
			width: "auto",
			cellHorAlign: "left",
			headHorAlign: "left",
			rowSpan: "2",
			headHeight: "30px",
			marginLeft: "10px",
			colSpan: "2",
		},
		{
			name: "cost",
			title: (
				<div>
					<span>Сметная стоимость, тыс. руб</span>
					<PriceLevelSwitcher
						headerData={headerData}
						priceLevel={priceLevel}
						setPriceLevel={setPriceLevel}
						priceLevelText="Уровень цен"
						baseText="базисный"
						curText="текущий"
					/>
				</div>
			),
			width: "550px",
			cellHorAlign: "left",
			headHorAlign: "center",
			headHeight: "30px",
			colSpan: "5",
			children: [
				{
					name: "building",
					title: "строительных работ",
					width: "110px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "50px",
				},
				{
					name: "mounting",
					title: "монтажных работ",
					width: "110px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "50px",
				},
				{
					name: "equipment",
					title: "оборудования",
					width: "110px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "50px",
				},
				{
					name: "other",
					title: "прочих затрат",
					width: "110px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "50px",
				},
				{
					name: "total",
					title: "всего",
					width: "110px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "50px",
				},
			],
		},
		{
			name: "check",
			title: "",
			width: "20px",
			cellHorAlign: "center",
			headHorAlign: "left",
			rowSpan: "2",
			headHeight: "25px",
			marginLeft: "10px",
		},
	];
}
